import { render, staticRenderFns } from "./StepTermsAndConditionsComponent.vue?vue&type=template&id=484d1552&scoped=true&"
import script from "./StepTermsAndConditionsComponent.vue?vue&type=script&lang=js&"
export * from "./StepTermsAndConditionsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484d1552",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCheckbox,VContainer,VLayout})
